import {
  TJobValuesOverlay, TOverlayBucketSize,
} from '../interface/job-values.ts';

const overlayOptions: Record<TJobValuesOverlay, string> = {
  shewhart: 'Shewhart',
  distribution: 'Verteilung',
  average: 'Durchschnitt',
  median: 'Median',
  nothing: 'Keine Hilfslinien',
};

const overlayBucketSizeOptions: Record<TOverlayBucketSize, string> = {
  total: 'Gesamt',
  year: 'Jahr',
  quarter: 'Quartal',
  month: 'Monat',
  week: 'Woche',
};

export default {
  rollingAverageSize: 'Größe des gleitenden Durchschnitts',
  showRollingAverage: 'Gleitender Durchschnitt',
  selectOverlay: 'Hilfslinien',
  showOverlayLabel: 'Hilfslinienbeschriftung',
  overlayBucketSize: 'Zeitfenster',
  overlayOptions,
  overlayBucketSizeOptions,
};
